export const productSerialMessage = (product, serialNumber, partNumber) => {
  if (!product) return;

  const length = product.serialNumberLength;
  const type = product.serialNumberType;

  // TODO implement proper pipeline functional pattern
  return [
    // check for numeric
    () => (type && type === 'Numeric' && !serialNumber.match(/^\d+$/) && 'a Numeric Serial Number') || '',
    // check for alphanumeric
    (message) => (!message && type && type === 'Alphanumeric' && !serialNumber.match(/^[a-zA-Z0-9]*$/) && 'an Alphanumeric Serial Number') || message,
    // check for length
    (message) => (length && type && length !== serialNumber.length && `${type === 'Numeric' ? 'a' : 'an'} ${type} Serial Number of ${length} digits`) || message,
    // Wrap complete message
    (message) => (message ? `Part number ${partNumber} requires ${message}. Please verify the Part Number and/or Serial Number and try again.` : ''),
  ].reduce((prev, curr) => curr(prev), undefined);
};
